module.exports = __webpack_public_path__ + "hero-next-1687-0e367fa280a575f1ce1dea77d316487d.bundle.webp";